import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import TemporaryRejectJobsModal from '../../components/TemporaryRejectJobsModal'
import profileModal from '../../components/profileModal'
import JobService from '../../services/jobService'
import TemporaryDetailModal from '../../components/TemporaryDetailModal'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      profilemodalActive: false,
      jobs: [],
      constJobs: [],
      loading: false,
      selected: '',
      selected2: '',
      showMessage: false,
      showMessage2: false,
      showMessage3: false,
      showMessage4: false,
      search1: '',
      search2: '',
      search3: '',
      search4: '',
      sort: false,
      professionalId: '',
      applId: '',
      modalPhoneActive: false
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    TemporaryRejectJobsModal,
    profileModal,
    TemporaryDetailModal
  },
  mounted () {
    // window.analytics.page('onGoingJobs')
    window.analytics.identify('onGoingJobs', {
      path: '/onGoingJobs'
    })
  },
  async created () {
    this.loading = true
    this.jobs = await JobService.listApplications('ONGOING')
    this.constJobs = this.jobs
    this.hospitals = await JobService.listBranches()
    this.professions = await JobService.listProfessions()
    this.loading = false
  },
  methods: {
    uploadModal (id) {
      this.applId = id
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    profileModal (id) {
      this.professionalId = id
      this.profilemodalActive = true
      document.body.classList.add('overlayBg')
    },
    verifyPhone (data) {
      this.job = data
      this.modalPhoneActive = true
      document.body.classList.add('overlayBg')
    },
    closeReject (bool) {
      if (!bool) this.modalPhoneActive = !this.modalPhoneActive
      else this.modalPhoneActive = null
      document.body.classList.remove('overlayBg')
    },
    async close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
      this.jobs = await JobService.listApplications('ONGOING')
    },
    closeprofileModal (bool) {
      if (!bool) this.profilemodalActive = !this.profilemodalActive
      else this.profilemodalActive = null
      document.body.classList.remove('overlayBg')
    },
    getDate (data) {
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(date))
      return res
    },
    departmentSearch () {
      this.jobs = this.constJobs
      // console.log(this.jobs)
      const filteredJobs = this.jobs.filter(job => {
        return job.job.department.toLowerCase().includes(this.search1.toLowerCase())
      })
      this.jobs = filteredJobs
      // this.search1 = ''
      this.showMessage = false
    },
    specializationSearch () {
      this.jobs = this.constJobs
      // console.log(this.jobs)
      const filteredJobs = this.jobs.filter(job => {
        return job.job.specialization.toLowerCase().includes(this.search2.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage2 = false
    },
    nameSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.professional.name.full.toLowerCase().includes(this.search4.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage3 = false
    },
    shiftSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.job.shift.toLowerCase().includes(this.search3.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage4 = false
    },
    async reset () {
      await this.$router.push('/upcoming_jobs')
      this.$router.push('/ongoing_jobs')
    },
    async onChange (event) {
      // this.selected2 = ''
      const hospitalId = event.target.value
      // console.log(event.target.value)
      this.jobs = await JobService.getJobsByProfessions('ONGOING', this.selected2, hospitalId)
      // console.log(this.jobs)
    },
    async onChange2 (event) {
      // this.selected = ''
      const professionId = event.target.value
      this.jobs = await JobService.getJobsByProfessions('ONGOING', professionId, this.selected)
      // console.log(this.jobs)
    },
    convertDate (d) {
      const d1 = new Date(d).toLocaleDateString()
      // console.log(d1)
      var p = d1.split('/')
      return (p[2] + p[1] + p[0])
    },
    sortByDate () {
      const that = this
      var tbody = document.querySelector('.table tbody')
      var rows = [].slice.call(tbody.querySelectorAll('tr'))
      if (!this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(a.cells[4].innerHTML) - that.convertDate(b.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      } else if (this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(b.cells[4].innerHTML) - that.convertDate(a.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      }
      this.sort = !this.sort
    },
    sortId () {
      this.jobs = this.constJobs
      if (!this.sort) {
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.job.code.substring(2)
          const end = b.job.code.substring(2)
          return start - end
        })
        this.jobs = sortedJobs
      } else if (this.sort) {
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.job.code.substring(2)
          const end = b.job.code.substring(2)
          return end - start
        })
        this.jobs = sortedJobs
      }
      this.sort = !this.sort
    }
  }
}
